import { render, staticRenderFns } from "./ClockType.vue?vue&type=template&id=1c731856&scoped=true"
import script from "./ClockType.vue?vue&type=script&lang=js"
export * from "./ClockType.vue?vue&type=script&lang=js"
import style0 from "./ClockType.vue?vue&type=style&index=0&id=1c731856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c731856",
  null
  
)

export default component.exports